import React from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { Modal, Button } from 'fpay-ui';
import { FUNDS_OUT } from '@constants/routes';
import { useBreakpoints } from '@hooks/NewBreakpoint';

const Container = styled.div(
  ({ theme }) => css`
    display: block;
    text-align: center;
    justify-content: center;
    padding: 0 40px 32px 40px;
    height: 100%;
    width: 100%;
    margin: auto;
    ${theme.breakpoint('md')} {
      height: 100%;
      width: 100%;
    }
  `
);

const Image = styled.img`
  height: 93px;
  width: 86.3px;
`;

const Title = styled.div(
  ({ theme }) => css`
    ${theme.textTypes['Title-w700']}
    margin: 48px 0 16px 0;
    ${({ theme }) => theme.newBreakpoint('sm')} {
      margin: 32px 0 16px 0;
    }
  `
);

const Description = styled.div(
  ({ theme }) => css`
    ${theme.textTypes['Description-w700']}
    text-align: center;
    margin-bottom: 40px;
  `
);

const ContentIcon = styled.div(
  () => css`
    background: #fce6ec;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 128px;
    ${({ theme }) => theme.newBreakpoint('sm')} {
      height: 96px;
    }
  `
);

const Icon = styled(Image)`
  width: 64px;
  height: 64px;
`;

export const ButtonConfirm = styled.button(
  ({ theme }) => css`
    width: 162px;
    height: 48px;
    border: 0;
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    font-weight: 400;
    color: ${theme.colors.gbrand500};
    text-align: center;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    display: flex;
    margin: 2px auto 0 auto;
    cursor: hand;
    ${theme.breakpoint('md')} {
      width: 99px;
    }
  `
);

const BlockedSellerModal = ({ fClose, fnConfirm }) => {
  const { t } = useTranslation();
  const { breakpoint } = useBreakpoints();
  const description = t('blockScreen.modal.description');
  const height = breakpoint === 'xs' ? '440px' : '460px';
  const width = breakpoint === 'xs' ? '328px' : '504px';
  return (
    <Modal
      showCloseButton={false}
      fClose={fClose}
      height={height}
      width={width}
      paddingLeft="0px"
      paddingRight="0px"
      borderRadius="6px"
    >
      <ContentIcon>
        <Icon src="tooltip-alert.svg" />
      </ContentIcon>
      <Container>
        <Title>{t('blockScreen.modal.title')}</Title>
        <Description>{parse(description)}</Description>

        <Link to={FUNDS_OUT} style={{ textDecoration: 'none' }}>
          <Button
            style={{
              width: '162px',
              height: '48px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              cursor: 'hand',
            }}
          >
            {t('blockScreen.modal.buttonRedirect')}
          </Button>
        </Link>
        <ButtonConfirm onClick={fnConfirm}>{t('blockScreen.modal.buttonConfirm')}</ButtonConfirm>
      </Container>
    </Modal>
  );
};

export default BlockedSellerModal;
